var _rect, _rect2, _rect3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGamification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 151,
    viewBox: "0 0 184 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 182,
    height: 149,
    rx: 11,
    fill: "white",
    stroke: "#A0A0A0",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 26,
    width: 26,
    height: 27,
    rx: 8,
    fill: "#D5D5D5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 109,
    width: 50,
    height: 16,
    rx: 4,
    fill: "#D5D5D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.625 64.75H69.3747C66.6705 64.75 64.458 66.9625 64.458 69.6667V89.3333C64.458 92.0375 66.6705 94.25 69.3747 94.25H113.625C116.329 94.25 118.541 92.0375 118.541 89.3333V69.6667C118.541 66.9625 116.329 64.75 113.625 64.75ZM113.625 89.3333H69.3747V69.6667H113.625V89.3333ZM76.7497 86.875H81.6663V81.9583H86.583V77.0417H81.6663V72.125H76.7497V77.0417H71.833V81.9583H76.7497V86.875Z",
    fill: "#B6B6B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6455 86.875C99.6821 86.875 101.333 85.224 101.333 83.1875C101.333 81.1509 99.6821 79.5 97.6455 79.5C95.609 79.5 93.958 81.1509 93.958 83.1875C93.958 85.224 95.609 86.875 97.6455 86.875Z",
    fill: "#B6B6B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.479 79.5C109.515 79.5 111.166 77.849 111.166 75.8125C111.166 73.7759 109.515 72.125 107.479 72.125C105.442 72.125 103.791 73.7759 103.791 75.8125C103.791 77.849 105.442 79.5 107.479 79.5Z",
    fill: "#B6B6B6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamification);
export default __webpack_public_path__ + "static/media/gamification.f1779395d4bbf40b67e81ae668500e5b.svg";
export { ForwardRef as ReactComponent };